import { render, staticRenderFns } from "./RmDashboard.vue?vue&type=template&id=73bc3474&scoped=true"
import script from "./RmDashboard.vue?vue&type=script&lang=js"
export * from "./RmDashboard.vue?vue&type=script&lang=js"
import style0 from "./RmDashboard.vue?vue&type=style&index=0&id=73bc3474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bc3474",
  null
  
)

export default component.exports